import { useAuthStore, useHydrateSession } from "@/features/auth/useAuth";
import { Box, CircularProgress } from "@mui/material";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export function RequireAuth() {
  useHydrateSession();
  const { status } = useAuthStore();
  const location = useLocation();

  if (status === "unknown") {
    return (
      <Box
        sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}
      >
        <CircularProgress />
      </Box>
    );
  }
  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
